module.exports = function ($q, resourceInjector, settingsService) {

    let result;

    function getGoogleMapsApi(url) {
        const deferred = $q.defer();
        url = url + '&callback=onGoogleMapsReady';

        if (resourceInjector.isScriptInjected(url) && window.google && window.google.maps) {
            deferred.resolve(window.google);
            return deferred.promise;
        }

        window.onGoogleMapsReady = function () {
            delete window.onGoogleMapsReady;
            deferred.resolve(window.google);
        };

        resourceInjector.injectScript(url);

        return deferred.promise;
    }

    if (!navigator.userAgent || navigator.userAgent.indexOf('Prerender') === -1) {
        result = function (url) {
            return settingsService.getSettingValue('TrackMyOrderETA', 'GoogleMapApiUrl')
                .then(function (trackMyOrderMapsUrl) {
                    url = url || trackMyOrderMapsUrl;
                    return getGoogleMapsApi(url);
                });
        };
    } else {
        result = function () {}; //Return an noop for Prerender as it fails
    }
    return result;

};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/googlemaps/google-maps-api-factory.js
 **/